<template>
  <div>
    <span class="first">{{array[0].name}} ({{array[0].theme.name}})</span>

    <span class="more" v-if="array.length > 1" @click="visible = !visible">
      <span v-if="!visible"> +{{array.length - 1}} </span>

      <span v-if="visible">
        <font-awesome-icon icon="angle-up"/>
      </span>
    </span>
    <transition name="fadeHeight">
      <div v-if="visible">
        <span v-for="(group, i) in array" v-if="i>0" :key="group.id">
          {{group.name}} <span>({{group.theme.name}})</span>
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'player-dropdown-list',
    props: ['array'],
    data () {
      return {
        visible: false
      }
    }
  }
</script>

<style scoped lang="scss">
  .fadeHeight-enter-active,
  .fadeHeight-leave-active {
    transition: all 0.3s;
    max-height: 230px;
  }

  .fadeHeight-enter-active {
    transition: all 0.6s;

  }

  .fadeHeight-enter,
  .fadeHeight-leave-to {
    overflow: hidden;
    opacity: 0;
    max-height: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/players/DropdownList.vue